export default {
  label: 'Хотим поделиться интересными фактами о нас, пока идет установка вашего облака...',
  facts: [
    'Наша техподдержка доступна 24/7 во всех часовых поясах',
    'Каждый день более 50 фуд-проектов делают выбор в пользу Quick Resto',
    'Фудтрак или спортивная арена — Quick Resto подходит для любого формата',
    'В МГТУ им. Н. Э. Баумана 48 точек общепита — их все обслуживает Quick Resto',
    '200 штук за 17 минут: столько чеков выбивается на одном кассовом терминале Quick Resto в перерыве между периодами на хоккейной Арене Металлург',
  ],
}
